package net.lateinit.bug_or_feature.site.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun Toast(
    message: String,
    isVisible: Boolean,
    type: ToastType = ToastType.Success,
    onDismiss: () -> Unit = {}
) {
    if (!isVisible) return
    
    Div({
        style {
            property("position", "fixed")
            property("bottom", "24px")
            property("right", "24px")
            property("padding", "12px 20px")
            property("border-radius", "12px")
            property("background", when(type) {
                ToastType.Success -> "#22C55E"
                ToastType.Error -> "#EF4444"
                ToastType.Info -> "var(--accent)"
            })
            property("color", "#fff")
            property("box-shadow", "0 8px 24px rgba(0,0,0,0.15)")
            property("animation", "toastSlideIn 0.3s ease-out")
            property("z-index", "9999")
            property("font-size", "14px")
            property("font-weight", "500")
        }
    }) {
        Row(Modifier.gap(8.px).alignItems(AlignItems.Center)) {
            SpanText(when(type) {
                ToastType.Success -> "✓"
                ToastType.Error -> "✗"
                ToastType.Info -> "ℹ"
            })
            SpanText(message)
        }
    }
}

enum class ToastType {
    Success, Error, Info
}
